import React from 'react'
import { IconButton, SvgIconProps } from '@mui/material'
import { ChatListItemBase } from './chat-list-item-base'
import { nothing } from '$func/utils'

interface Props {
  avatarComponent: JSX.Element
  primaryText: JSX.Element
  primaryTextIcon?: JSX.Element
  secondaryText?: string | JSX.Element
  SecondaryActionIcon?: React.ComponentType<SvgIconProps>
  hasDivider?: boolean
  onClick?: () => unknown
  onSecondaryActionIconClick?: () => unknown
  verified?: boolean
  onContextMenu?: (e: MouseEvent) => void
}

export function ChatListItem({
  avatarComponent,
  primaryText,
  primaryTextIcon,
  verified = false,
  secondaryText = '',
  SecondaryActionIcon,
  hasDivider = true,
  onClick = nothing,
  onSecondaryActionIconClick = nothing,
  onContextMenu = nothing,
}: Props) {
  return (
    <ChatListItemBase
      primaryText={primaryText}
      primaryTextIcon={primaryTextIcon}
      verified={verified}
      secondaryText={secondaryText}
      avatarComponent={avatarComponent}
      secondaryActionComponent={
        SecondaryActionIcon ? (
          <IconButton
            sx={{ borderRadius: 0, width: '56px', height: '56px' }}
            size="large"
            onClick={e => {
              e.stopPropagation()
              onSecondaryActionIconClick()
            }}
          >
            <SecondaryActionIcon fill="#818181" />
          </IconButton>
        ) : (
          undefined
        )
      }
      hasDivider={hasDivider}
      onClick={onClick}
      onContextMenu={onContextMenu}
    />
  )
}
